// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W8p_t","option":"styles_option__2QJFx","active":"styles_active__1O-OH"};